import React, { Component } from "react";
import "../Styles/emlak-genel.css";
import SubHeader from "../Components/SubHeader";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import ContactForm from "../Components/ContactForm";
import Harita2 from "../Components/Harita2";

export default class Contact extends Component {
  render() {
    return (
      <>
        <SubHeader />
        <Header />
        <div className="page-heading header-text">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <span className="breadcrumb">
                  <a href="#">İletişim</a>
                </span>
                <h3>BİZE ULAŞIN</h3>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-page section">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="section-heading">
                  <h6>| BİZİMLE İLETİŞİME GEÇ</h6>
                  <h2>Acentelerimizle İletişime Geçin</h2>
                </div>
                <p>
                  RBA ile alım-satım işlemleriniz artık daha güvenli, hızlı ve
                  kolay! Gelişmiş altyapımız ve deneyimli ekibimiz sayesinde,
                  yatırımlarınızı en iyi fiyatlarla ve en avantajlı koşullarda
                  değerlendirme fırsatı sunuyoruz. Profesyonel destek ekibimiz,
                  piyasa analizleri ve stratejik yönlendirmelerle sizlere en
                  doğru kararları vermenizde yardımcı oluyor. Her adımda
                  şeffaflık, güven ve müşteri memnuniyetini ön planda tutarak,
                  işlemlerinizi sorunsuz bir şekilde gerçekleştirmenizi
                  sağlıyoruz. Size özel çözümler ve cazip fırsatlar hakkında
                  detaylı bilgi almak için bizimle iletişime geçebilir, uzman
                  desteğimizden faydalanabilirsiniz.
                </p>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="item phone">
                      <img
                        src="../Assets/Images/phone-icon.png"
                        alt=""
                        style={{ maxWidth: "52px" }}
                      />
                      <h6>
                        <span>Telefon Numaramız</span>
                        <br />
                        0 544 830 91 30 <br />0 222 222 0 722
                      </h6>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="item email">
                      <img
                        src="../Assets/Images/email-icon.png"
                        alt=""
                        style={{
                          maxWidth: "52px",
                          marginBottom: "15px",
                          marginTop: "15px",
                        }}
                      />
                      <h6>
                        <span>Email Adresimiz</span>
                        <br />
                        erkanbuyukarslan
                        <br />
                        @hotmail.com
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <ContactForm></ContactForm>
              </div>
              <Harita2 colNumber={12}></Harita2>

              <Harita2
                colNumber={12}
                embed={
                  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3058.936603994165!2d30.5276826!3d39.7700965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cc3d003d5b1ed7%3A0x9362d4c3f7b369aa!2sRba%20Emlak!5e0!3m2!1str!2str!4v1710000000000"
                }
              ></Harita2>
            </div>
          </div>
        </div>

        <Footer />
      </>
    );
  }
}
